import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import {
  AdvancedCardSearch,
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

import { PlayerDetails } from '@sorare/gameplay/src/components/player/PlayerDetails';

export const NBACardSearch = (
  props: Omit<FullProps, 'sport' | 'PlayerDetailsComponent'>
) => (
  <AdvancedCardSearch
    sport={Sport.NBA}
    PlayerDetailsComponent={PlayerDetails}
    {...props}
  />
);
